module.exports = ".intro-card {\r\n    position: relative;\r\n    width: 80%;\r\n    margin: auto;\r\n}\r\n\r\n.senate-table {\r\n    position: relative;\r\n    width: 80%;\r\n    margin: auto;\r\n}\r\n\r\n.table-header {\r\n    margin-left: 25px;\r\n}\r\n\r\n.mat-column-select {\r\n    overflow: initial;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/senate-members/senate-members.component.css
// module id = ./src/app/senate-members/senate-members.component.css
// module chunks = main